import React from "react";
import { Star } from "lucide-react";

const ReviewCard = ({ review, featured = false }) => {
  return (
    <div
      data-testid={`review-card-${review.id}`}
      className={`relative bg-white rounded-2xl border border-slate-200 p-6 sm:p-7 shadow-sm hover:shadow-md transition-shadow ${
        featured ? "lg:col-span-2" : ""
      }`}
    >
      <div className="flex items-center gap-1 mb-3">
        {Array.from({ length: review.rating }).map((_, i) => (
          <Star key={i} className="h-4 w-4 fill-amber-400 text-amber-400" />
        ))}
      </div>
      <blockquote className="text-brand-navy text-base sm:text-lg leading-relaxed mb-4">
        “{review.text}”
      </blockquote>
      <div className="flex items-center gap-3 pt-3 border-t border-slate-100">
        <div className="h-10 w-10 rounded-full bg-brand-blue-soft flex items-center justify-center text-brand-blue font-bold text-sm">
          {review.name.charAt(0)}
        </div>
        <div>
          <p className="text-sm font-bold text-brand-navy">{review.name}</p>
          {review.role && (
            <p className="text-xs text-slate-500">{review.role}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
